import { reduce, keys } from 'ramda'

export const format = (str, obj = {}) =>
  reduce((acc, key) => acc.replace(`:${key}`, obj[key]), str, keys(obj))
